import type { QueuedShow } from "@/app/_services/CartService";

const entryKey = (showId: string) => `cuo_queue:${showId}`;
const AFTER_CHECKOUT_KEY = "cuo_queue_after_checkout";

// The buyer's place in line per show; localStorage so a refresh or new tab keeps it.
export function storedQueueEntry(showId: string | undefined): string | null {
  if (!showId) return null;
  try {
    return localStorage.getItem(entryKey(showId));
  } catch {
    return null;
  }
}

export function storeQueueEntry(showId: string, entryId: string | null) {
  try {
    if (entryId) localStorage.setItem(entryKey(showId), entryId);
    else localStorage.removeItem(entryKey(showId));
  } catch {}
}

// Shows queued while the rest of the cart checks out; read by the checkout and success pages.
export function stashQueuedAfterCheckout(queued: QueuedShow[]) {
  try {
    if (queued.length) sessionStorage.setItem(AFTER_CHECKOUT_KEY, JSON.stringify(queued));
    else sessionStorage.removeItem(AFTER_CHECKOUT_KEY);
  } catch {}
}

export function loadQueuedAfterCheckout(): QueuedShow[] {
  try {
    return JSON.parse(sessionStorage.getItem(AFTER_CHECKOUT_KEY) || "[]");
  } catch {
    return [];
  }
}

export function clearQueuedAfterCheckout() {
  try {
    sessionStorage.removeItem(AFTER_CHECKOUT_KEY);
  } catch {}
}
